module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioPrimerExamenAdminProyectos.5e1a6dba.pdf";